/* CSS injector — bypasses stale page cache */
(function(){
  var l=document.createElement('link');
  l.rel='stylesheet';l.type='text/css';
  l.href='https://cdn.shopify.com/s/files/1/0908/8021/3367/t/3/assets/customs-form-override.css';
  document.head.appendChild(l);
})();

document.addEventListener('DOMContentLoaded', () => {
  /* ─────────────────────────────────────────────
   * 1. Before submit → collect values & inject body
   * ──────────────────────────────────────────── */
  const form = document.querySelector('.customs-simple-request form');
  if (form) {
    form.addEventListener('submit', (event) => {
      // Collect all field values
      const values = {
        first:      form.querySelector("input[name='contact[first_name]']")?.value || "",
        last:       form.querySelector("input[name='contact[last_name]']")?.value || "",
        email:      form.querySelector("input[name='contact[email]']")?.value || "",
        comp:       form.querySelector("input[name='contact[company]']")?.value || "",
        phone:      form.querySelector("input[name='contact[phone]']")?.value || "",
        website:    form.querySelector("input[name='contact[website]']")?.value || "",
        social_url: form.querySelector("input[name='contact[social_url]']")?.value || "",
        qty:        form.querySelector("input[name='contact[quantity]']")?.value || "",
        budget:     form.querySelector("input[name='contact[budget]']")?.value || "",
        about:      form.querySelector("textarea[name='contact[project]']")?.value || "",
        designs:    form.querySelector("select[name='contact[designs_needed]']")?.value || "",
        model:      form.querySelector("select[name='contact[model_choice]']")?.value || ""
      };

      // Save JSON for n8n later
      localStorage.setItem("shopifyFormPayload", JSON.stringify(values));
      console.log("💾 Saved payload to localStorage:", values);

      // Build Shopify email-friendly summary
      const summary = `
New custom order request:
- First Name: ${values.first}
- Last Name: ${values.last}
- Email: ${values.email}
- Company: ${values.comp}
- Phone: ${values.phone}
- Website: ${values.website}
- Social URL: ${values.social_url}
- Quantity: ${values.qty}
- Budget: ${values.budget}
- Designs Needed: ${values.designs}
- Model: ${values.model}
- Details: ${values.about}
      `.trim();

      // Do NOT inject Shopify contact[body], we only want n8n to handle it
      console.log("🛑 Skipping Shopify notification injection, using n8n only");

      console.log("📧 Injected hidden body:", hidden.value);
    }, { capture: true }); // capture ensures this runs before Shopify’s own handler
  }

  /* ─────────────────────────────────────────────
   * 2. On success page → retrieve + send to n8n
   * ──────────────────────────────────────────── */
  const params = new URLSearchParams(window.location.search);
  if (params.get("contact_posted") === "true") {
    console.log("✅ Shopify form posted — preparing payload…");

    let payload = {
      source: "Shopify Form",
      timestamp: new Date().toISOString()
    };

    // Pull back from localStorage
    const saved = localStorage.getItem("shopifyFormPayload");
    if (saved) {
      try {
        payload = { ...payload, ...JSON.parse(saved) };
      } catch (e) {
        console.warn("⚠️ Could not parse saved payload", e);
      }
    }

    console.log("🚀 Payload ready for n8n:", payload);

    const url = "https://dansutowel.app.n8n.cloud/webhook/37aa750b-72f9-4747-9de5-ec40d3c23e9b";
    const blob = new Blob([JSON.stringify(payload)], { type: "text/plain;charset=UTF-8" });

    try {
      const ok = navigator.sendBeacon(url, blob);
      if (ok) {
        console.log("📬 Payload sent via sendBeacon");
      } else {
        console.warn("⚠️ sendBeacon failed — falling back to fetch");
        fallbackFetch(url, blob);
      }
    } catch (e) {
      console.error("❌ Beacon error:", e);
      fallbackFetch(url, blob);
    }

    // Clean up after success
    localStorage.removeItem("shopifyFormPayload");
  }

  /* ─────────────────────────────────────────────
   * 3. Helper: fetch fallback
   * ──────────────────────────────────────────── */
  function fallbackFetch(url, blob) {
    fetch(url, { method: "POST", body: blob, mode: "no-cors", keepalive: true })
      .then(() => console.log("📬 Payload sent via fetch(no-cors)"))
      .catch(err => console.error("❌ Fetch error:", err));
  }
});